import CreateEditSectionPopup
    from '~/angular/app/wiki/wiki_main_page/createEditSectionFactory/CreateEditSectionPopup.vue';


createEditSectionFactory.$inject = ['simplePopupFactory', '$q', 'addMedia', '$log'];

function createEditSectionFactory(simplePopupFactory, $q, addMedia, $log) {

    let DEFAULT_GROUP_DATA = {
        caption: '',
        audio_caption: undefined,
        avatar: undefined,
        is_submenu: false,

    };

    async function main_options(initial, popup_config = {}, promise_to_resolve, is_circle_group = false) {
        /**
         * @param initial {Object}
         * {name:string,
         * description: string,
         * avatar: MediaContent
         * }
         * @return {Object} as above but filled\changed
         */
        let DEFAULT_POPUP_CONFIG = {
            header: 'Create New Wiki Section',
            save_button: 'Create',
            cancel_button: 'Cancel',
            allow_create_subsections: false,
            create_subsection_switch_disabled: false,
            additional_info: undefined,
            allow_delete: false
        };
        let actual_popup_config = Object.assign({}, DEFAULT_POPUP_CONFIG, popup_config);
        let initial_data = Object.assign({}, DEFAULT_GROUP_DATA, initial);
        let options_result = promise_to_resolve === undefined ? $q.defer() : promise_to_resolve;
        const {
            vm,
            popupComponent
        } = simplePopupFactory.mount_vue_popup(CreateEditSectionPopup);
        let popup_result = popupComponent.show(
            actual_popup_config, initial_data
        );

        popup_result.then(res => {
            if (res.type === 'delete') {
                options_result.resolve('delete');
            }
            if (res.type === 'save') {
                let data_to_resolve = res.data;
                if (!res.data.avatar) {
                    data_to_resolve.reset_avatar = true;
                }
                if (!res.data.audio_caption) {
                    data_to_resolve.reset_audio_caption = true;
                }
                if (res.data.avatar) {
                    data_to_resolve.media_for_avatar_id = res.data.avatar.pk;
                    delete res.data.avatar;
                }
                if (res.data.audio_caption) {
                    data_to_resolve.media_for_audio_caption_id = res.data.audio_caption.pk;
                    delete res.data.audio_caption;
                }
                options_result.resolve(data_to_resolve);
            }
        }, ).finally(() => {
            vm?.$destroy();
        });

        return options_result.promise;
    }

    return { main_options };
}

export default createEditSectionFactory;
